import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=c21e9afa&scoped=true"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"
import style0 from "./Step1.vue?vue&type=style&index=0&id=c21e9afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21e9afa",
  null
  
)

export default component.exports